import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Filter,
  TextInput,
} from 'react-admin';

const NotamsFilter: React.FC = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput source='id'/>
      <TextInput source='body'/>
      <TextInput source='status'/>
      <TextInput source='log'/>
      <TextInput source='resultNotamsIds'/>
    </Filter>
  );
};

const NotamsList: React.FC = (props: any) => {
  return (
    <List
      filters={<NotamsFilter/>}
      sort={{ field: 'id', order: 'DESC' }}
      {...props}
    >
      <Datagrid
        rowClick='edit'
      >
        <TextField source='id'/>
        <TextField source='status'/>
        <TextField source='body'/>
        <TextField source='recvAt'/>
        <TextField source='sendAt'/>
        <TextField source='tableName'/>
        <TextField source='log' cellClassName='long-text' />
        <TextField source='resultNotamsIds'/>
        
      </Datagrid>
    </List>
  );
};

export default NotamsList;